module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-tittle"
  }, [_c('span', [_vm._v("THE CAZALET FAMILY AND THEIR SERVANTS")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("William Cazalet, known as the Brig")]), _vm._v(" "), _c('p', {
    staticClass: "fm-04"
  }, [_vm._v("Kitty Barlow, known as the Duchy (his wife)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-05"
  }, [_vm._v("Rachel, their unmarried daughter")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Hugh Cazalet, eldest son")]), _vm._v(" "), _c('p', {
    staticClass: "fm-04"
  }, [_vm._v("Sybil Carter (his wife)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-05"
  }, [_vm._v("Polly")]), _vm._v(" "), _c('p', {
    staticClass: "fm-05"
  }, [_vm._v("Simon")]), _vm._v(" "), _c('p', {
    staticClass: "fm-05"
  }, [_vm._v("William, known as Wills")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Edward Cazalet, second son")]), _vm._v(" "), _c('p', {
    staticClass: "fm-04"
  }, [_vm._v("Viola, known as Villy (his wife)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-05"
  }, [_vm._v("Louise")]), _vm._v(" "), _c('p', {
    staticClass: "fm-05"
  }, [_vm._v("Teddy")]), _vm._v(" "), _c('p', {
    staticClass: "fm-05"
  }, [_vm._v("Lydia")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Rupert Cazalet, third son")]), _vm._v(" "), _c('p', {
    staticClass: "fm-04"
  }, [_vm._v("Zoë (second wife)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-04"
  }, [_vm._v("Isobel (first wife; died having Neville)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-05"
  }, [_vm._v("Clarissa, known as Clary")]), _vm._v(" "), _c('p', {
    staticClass: "fm-05"
  }, [_vm._v("Neville")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Jessica Castle (Villy’s sister)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-04"
  }, [_vm._v("Raymond (her husband)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-05"
  }, [_vm._v("Angela")]), _vm._v(" "), _c('p', {
    staticClass: "fm-05"
  }, [_vm._v("Christopher")]), _vm._v(" "), _c('p', {
    staticClass: "fm-05"
  }, [_vm._v("Nora")]), _vm._v(" "), _c('p', {
    staticClass: "fm-05"
  }, [_vm._v("Judy")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Mrs Cripps (cook)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03a"
  }, [_vm._v("Eileen (parlourmaid)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03a"
  }, [_vm._v("Peggy and Bertha (housemaids)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03a"
  }, [_vm._v("Dotty (kitchenmaid)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03a"
  }, [_vm._v("Tonbridge (chauffeur)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03a"
  }, [_vm._v("McAlpine (gardener)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03a"
  }, [_vm._v("Wren (groom)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03a"
  }, [_vm._v("Billy (gardener’s boy)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Nanny")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03a"
  }, [_vm._v("Inge (German maid)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Emily (cook)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03a"
  }, [_vm._v("Phyllis (parlourmaid)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03a"
  }, [_vm._v("Edna (housemaid)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03a"
  }, [_vm._v("Nanny")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03a"
  }, [_vm._v("Edie (daily help in the country)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Ellen (nurse)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4984e832","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter04.vue
// module id = 75
// module chunks = 0